import React, { useEffect } from "react";
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import SetPassword from "./SetPassword";
import { useNavigate } from "react-router-dom";

const SetPasswordContainer: React.FC = () => {
    const { state, validatePasswordRequirements, initializePassword, finishPasswordReset } = useAuthenticationStore();
    const { serverError, isLoading, email, verifiedNonceToken } = state;
    const navigate = useNavigate();

    useEffect(() => {
        if (!verifiedNonceToken) {
            navigate("../" + AuthenticationViews.login);
        }
    }, [verifiedNonceToken, navigate]);

    return (
        <SetPassword
            serverError={serverError}
            isLoading={isLoading}
            isPasswordInit={state.activeView === AuthenticationViews.initializePassword}
            email={email}
            validatePasswordRequirements={validatePasswordRequirements}
            updatePassword={
                state.activeView === AuthenticationViews.initializePassword ? initializePassword : finishPasswordReset
            }
        />
    );
};

export default SetPasswordContainer;
